import {
  parse as fnsParse,
  format,
  isValid,
  addMonths,
  parseISO,
} from 'date-fns'
import { datetime } from '~/shared/config'

export { addMonths, format as formatDate, format }

export const fromDateStringApi = (input: string) =>
  fnsParse(input, datetime.apiDateFormat, new Date())

export const fromDataTimeStringApi = (input: string) =>
  fnsParse(input, datetime.apiDateTimeFormat, new Date())

export const fromDatetimeString = (input: string) => parseISO(input)

export const isValidDateString = (input: string) =>
  isValid(fromDateStringApi(input))

export const formatDateForApi = (date: Date) =>
  format(date, datetime.apiDateFormat)

export const formatDateTimeForApi = (date: Date) =>
  format(date, datetime.apiDateTimeFormat)

export const formatDateForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateFormat)

export const formatDateTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateTimeFormat)

export const formatTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiTimeFormat)
